// extracted by mini-css-extract-plugin
export default {"brass-button-secundary":"ButtonV1_brass-button-secundary__p2R5E","brass-button-round":"ButtonV1_brass-button-round__ISPN7"};